import { handleActions } from 'redux-actions'
import * as type from './type'

const isTablet = !!navigator.userAgent.match(/Tablet|iPad|iPod/i)

export const initialState = {
    isNavigationCollapsed: isTablet || window.innerWidth < 600,
    isTablet: isTablet,
}


export default handleActions({
    [type.TOGGLE_NAVIGATION]: (state, action) => {
        return {
            ...state,
            isNavigationCollapsed: !state.isNavigationCollapsed,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/layout/state/reducer.js